/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const IN_EUROPE = 'IN_EUROPE';
export const OUT_OF_EUROPE = 'OUT_OF_EUROPE';
